const initLayoutConfig = {
  lg: [],
  md: [],
  sm: [],
  xs: [],
}

export default initLayoutConfig
